import React, { useMemo } from 'react';
import { NavLink, matchPath, useLocation } from 'react-router-dom';
import { Icon } from '@fourthwall/components';
import { routing } from '@utils/routing';
import * as S from './styled';
export const DashboardMenuItem = ({ label, icon, activeIcon, rightIcon, to, as = NavLink, children, onClick, }) => {
    const location = useLocation();
    const matched = useMemo(() => {
        return !!matchPath({ path: String(to), end: to === routing.home }, location.pathname);
    }, [location, to]);
    const renderIcon = () => {
        if (!icon)
            return React.createElement("div", { style: { width: 16 } });
        return React.createElement(Icon, { component: matched && activeIcon ? activeIcon : icon, height: 16 });
    };
    return (React.createElement(S.Container, { onClick: onClick },
        to ? (React.createElement(S.Link, { as: as, to: to, href: as === 'a' ? to : undefined, "$active": matched && !children },
            React.createElement(S.Wrapper, null,
                renderIcon(),
                React.createElement(S.Label, null, label),
                rightIcon))) : (React.createElement(S.Button, { type: "button" },
            React.createElement(S.Wrapper, null,
                icon ? React.createElement(Icon, { component: icon, height: 16 }) : React.createElement("div", { style: { width: 16 } }),
                React.createElement(S.Label, null, label),
                rightIcon))),
        children));
};
